// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"58cabc45","455":"1ccf45a7"}[chunkId] + ".chunk.js";
};